/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import Pikaday from "pikaday";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import util from "./util.js";
dayjs.extend(customParseFormat);

function getter(valueAccessor, useISO) {
  return function() {
    var date = ko.unwrap(valueAccessor());
    if(date) {
      return useISO ? util.parseISODate(date) : date;
    } else {
      return null;
    }
  }
}

function setter(valueAccessor, useISO) {
  return function(date) {
    if(date && useISO) {
      date = util.formatISODate(date);
    }
    valueAccessor()(date);
  }
}

ko.bindingHandlers.pikaday = {
  init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var useISO = allBindings.has('pikadayISO');
    var getBoundValue = getter(valueAccessor, useISO);
    var setBoundValue = setter(valueAccessor, useISO);

    var disableDayFn;
    if(allBindings.has('pikadayDateDisabled')) {
      disableDayFn = allBindings.get('pikadayDateDisabled');
    }

    var field, container, trigger;
    if(element.tagName == "INPUT") {
      field = element;
    } else if(allBindings.has('pikadayContainer') && allBindings.get('pikadayContainer')) {
      container = element;
    } else {
      trigger = element;
      field = field || document.createElement("input");
    }

    var picker = new Pikaday({
      field: field,
      trigger: trigger,
      onSelect: function(date) {
        setBoundValue(date);
      },
      format: 'DD/MM/YYYY',
      disableDayFn: disableDayFn,
      toString: function(date, format) {
        return dayjs(date).format(format);
      },
      parse: function(dateString, format) {
        // It turns out dayjs parsing is not great. This is the current workaround.
        if(!dateString) {
          return null;
        }

        var match = dateString.trim().match(/^([0-9]{1,2})\s*\/\s*([0-9]{1,2})\s*\/\s*([0-9]{2,4})/)
        if(!match) {
          return null;
        }

        var d = +match[1];
        var m = +match[2] - 1;
        var y = +match[3];

        if(y < 100) {
          var cy = new Date().getFullYear();
          y += cy - (cy % 100);
          if(y > cy) {
            y -= 100;
          }
        }

        var date = new Date(y, m, d);
        if(date.getFullYear() == y && date.getMonth() == m && date.getDate() == d) {
          return date;
        } else {
          return null;
        }

        return date;

        // var date = dayjs(dateString, ['DD/MM/YYYY', 'D/M/YY', 'D/M/YYYY'], false /*formatStrict*/);
        // return (date && date.isValid()) ? date.toDate() : null;
      },
      keyboardInput: false
    });

    picker.setDate(getBoundValue());

    // Set value to null when user clears input field
    if(field) {
      element.addEventListener('change', function() {
        if(element.value == '' && getBoundValue() != null) {
          setBoundValue(null);
        }
      });
    }
    if(container) {
      container.appendChild(picker.el);
    }

    ko.utils.domData.set(element, 'ko-pikaday', picker);

    if(allBindings.has('pikadayPicker')) {
      allBindings.get('pikadayPicker')(picker);
    }
    if(allBindings.has('pikadayConfigure')) {
      allBindings.get('pikadayConfigure')(picker);
    }
  },
  update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var picker = ko.utils.domData.get(element, 'ko-pikaday');
    var useISO = allBindings.has('pikadayISO');
    var getBoundValue = getter(valueAccessor, useISO);

    var currentDate = picker.getDate();
    var newDate = getBoundValue();

    // Only update if necessary
    if((+currentDate) != (+newDate)) {
      picker.setDate(newDate);
    }
  }
};

ko.bindingHandlers.pikadayISO = ko.bindingHandlers.pikaday;
